import React from 'react'
import { useParams } from 'react-router-dom'
import Dispatch from './Dispatch'

/**
 * A restaurant's Dispatch: the super admin board, over this restaurant's
 * orders and its own drivers. One component, so the two screens can't drift.
 */
const DispatchRestaurant = () => {
  const params = useParams()
  let restaurantId = params.id
  if (!restaurantId) {
    try {
      restaurantId = localStorage.getItem('restaurantId')
    } catch (e) {
      restaurantId = null
    }
  }
  if (!restaurantId) return null
  // Keyed so switching restaurants starts a fresh board rather than mixing orders.
  return <Dispatch key={restaurantId} restaurantId={String(restaurantId)} />
}

export default DispatchRestaurant
